"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.integrations = void 0;
const data_access_1 = require("@resclick/data-access");
exports.integrations = {
    createIntegration: {
        dto: data_access_1.IntegrationCreateDto,
        method: 'post',
        path: '/integrations/provider',
        response: {},
    },
    updateIntegration: {
        dto: data_access_1.IntegrationUpdateDto,
        method: 'put',
        params: ['providerId'],
        path: '/integrations/provider/:providerId',
        response: {},
    },
    flightDepartures: {
        dto: data_access_1.FlightDepartureDto,
        method: 'post',
        path: '/integrations/flight/departures',
        response: {},
    },
    flightArrivals: {
        dto: data_access_1.FlightArrivalDto,
        method: 'post',
        path: '/integrations/flight/arrivals',
        response: {},
    },
    flightCheckInDates: {
        dto: data_access_1.FlightCheckInDatesDto,
        method: 'post',
        path: '/integrations/flight/checkindates',
        response: {},
    },
    flightPrices: {
        dto: data_access_1.FlightPriceDto,
        method: 'post',
        path: '/integrations/flight/prices',
        response: {},
    },
    postToIntegration: {
        dto: data_access_1.PostToIntegrationDto,
        method: 'post',
        params: ['orderId'],
        path: '/integrations/postorder/:orderId',
        response: {},
    }
};
//# sourceMappingURL=integrations.api.js.map